export default "__VITE_ASSET__BZNxzkkn__"